<template>
  <div class="box">
    <h3 class="sub_tit">{{ title }}</h3>
    <div class="box_inner">
      <!-- DISPLAY TEXTAREA PROPS -->
      <p
        v-if="!editTextarea && $route.path !== '/selfbook/create'"
        class="meta_dscript review_more_wrap"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span class="txt_overflow" v-html="formattedText"> </span>
        <!-- TODO: @Stan: Pressing this 펼쳐보기 should expand and contract the text based on the maxchar limit. I think it is 1000, but I need to double check -->
        <button
          v-if="numLines > 5"
          :class="{ active: textExpanded }"
          class="more_read_view"
          @click="toggleExpandText"
        >
          <span class="an_t">{{ $t('library.textareabox.4555') }}</span>
        </button>
      </p>

      <!-- EDIT TEXTAREA MODE -->
      <!-- FIXME: @Tim: We'll likely need a WYSIWYG text editor here, but I'll confirm with the team by 6/1. -->
      <!-- TODO: @Stan: I'm trying to get TipTap working here, but having trouble tying it to my text-area. I especially like the 'Menu Bubble' option.
      Docs: https://tiptap.scrumpy.io/menu-bubble
       -->
      <div v-if="editTextarea || $route.path === '/selfbook/create'">
        <Editor
          :active-buttons="[
            'bold',
            'italic',
            'strike',
            'underline',
            'code',
            'paragraph',
            'h1',
            'h2',
            'h3',
            'bullet_list',
            'ordered_list',
            'blockquote',
            'code_block',
            'horizontal_rule'
          ]"
          :initial-content="text || `이곳에 ${title}를 작성하세요.`"
          @update="updateText"
        />
        <!-- Cancel / Save button box -->
        <div
          v-if="$route.path !== '/selfbook/create'"
          class="btn_wrap ar mt-20"
        >
          <div>
            <button class="box_btn dull" @click="toggleEditTextarea">
              <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
            </button>
          </div>
          <div>
            <button class="box_btn" @click="saveChanges">
              <span class="an_t">{{ $t('library.deletemodal.save') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Switch to Edit Mode -->
    <div
      v-if="!editTextarea && $route.path !== '/selfbook/create'"
      class="btn_wrap atr"
    >
      <a class="an_a" @click="toggleEditTextarea"
        ><span class="c_icon ico_edit_sbook"></span
        ><span class="an_t">{{ $t('library.textareabox.8629') }}</span></a
      >
    </div>
  </div>
</template>

<script>
import Editor from '@/components/common/TipTap/Editor.vue'

export default {
  name: 'TextareaBox',

  components: { Editor },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editTextarea: false,
      textExpanded: false
    }
  },
  computed: {
    formattedText() {
      if (this.textExpanded) {
        return this.text
      }
      return this.numLines > 5
        ? `${this.text.split(/\r*\n/).slice(0, 5).join('\n')} ...`
        : this.text
    },
    textValue: {
      get() {
        return this.text
      },
      set(text) {
        this.$emit('input', text)
      }
    },
    numLines() {
      return this.text.split(/\r*\n/).length
    }
  },
  methods: {
    toggleEditTextarea() {
      this.editTextarea = !this.editTextarea
      this.$emit('cancel')
    },
    toggleExpandText() {
      this.textExpanded = !this.textExpanded
      // TODO: @Stan: ADD method to expand, shrink text.length max chars from 500 to 1000
      // FIXME: @Tim: Probably should be an error message when user goes over max char length. Need to check design as it doesn't exist in publishing files
    },
    saveChanges() {
      this.$emit('save')
      this.toggleEditTextarea()
    },
    updateText(text) {
      //To sync with text prop
      this.$emit('update:text', text)
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-20 {
  margin-top: 20px;
}
.more_read_view {
  bottom: inherit;
}
.txt_overflow {
  white-space: pre-wrap;
}
</style>
